/* Image-only expanding preview gallery, inspired by CreativeCoder111's
   CodePen XWyjBab. Original Shopify media and the purchase form stay intact. */
(function () {
  'use strict';
  window.SuvornaProductGallery = {
    create(root) {
      const entries = [...root.querySelectorAll('[data-pdp-media]')].map(media => ({
        id: media.dataset.pdpMedia, media,
        image: media.querySelector('img'),
        thumb: root.querySelector(`[data-pdp-thumb="${media.dataset.pdpMedia}"] img`) || media.querySelector('img')
      }));
      if (!entries.length) return { sync(){}, dispose(){} };
      const signal = new AbortController();
      let index = Math.max(0,entries.findIndex(entry=>!entry.media.hidden));
      const surfaces = [], overlays = new Set(); let tween, busy=false, queued=null, internalSync=false, generation=0;
      const button = (label,text,action) => {
        const element = document.createElement('button'); element.type='button';
        element.setAttribute('aria-label',label); element.textContent=text; element.dataset.galleryAction=action; return element;
      };
      const clearTransition = () => { tween?.kill(); tween=null; overlays.forEach(node=>node.remove()); overlays.clear(); };
      const animate = (surface,route,direction,duration,onStep,onComplete) => {
        if(!window.gsap || matchMedia('(prefers-reduced-motion: reduce)').matches) { onComplete(); return; }
        const host=surface.host.querySelector('[data-pdp-opening-surface]');
        const layers=route.map(entry=>{
          const layer=document.createElement('div');layer.className='sv-pdp__gallery-flight';layer.setAttribute('aria-hidden','true');
          const img=document.createElement('img'),source=entry.image||entry.thumb;
          if(source){img.src=source.currentSrc||source.src;img.alt='';img.style.setProperty('--pdp-image-aspect',source.style.getPropertyValue('--pdp-image-aspect') || (source.naturalWidth/source.naturalHeight) || 1);['--pdp-img-fit','--pdp-img-position','--pdp-img-fill'].forEach(name=>{const value=source.style.getPropertyValue(name);if(value)img.style.setProperty(name,value);});layer.append(img);}
          host.append(layer);overlays.add(layer);return layer;
        });
        const position={value:0};
        const render=()=>{layers.forEach((layer,i)=>gsap.set(layer,{yPercent:(i-position.value)*110*direction}));onStep(Math.round(position.value));};
        render();
        tween=gsap.to(position,{value:route.length-1,duration,ease:'power2.inOut',onUpdate:render,onComplete:()=>{clearTransition();onComplete();}});
      };
      const select = (next,surface,origin,direction=1) => {
        next=(next+entries.length)%entries.length;
        // Finish the current roll, then honour the latest interaction. Never
        // replace a half-travelled cylinder with a different starting image.
        if(busy){queued={next,surface,origin,direction};return;}
        if(next===index)return;
        clearTransition();const start=index,route=[entries[start]];
        for(let i=start;i!==next;){i=(i+direction+entries.length)%entries.length;route.push(entries[i]);}
        const steps=route.length-1,duration=Math.min(2.8,.88+(steps-1)*.24),ticket=++generation;
        busy=true;
        surfaces.forEach(({host})=>host.setAttribute('aria-busy','true'));
        const onStep=step=>{if(ticket!==generation)return;const at=(start+direction*step+entries.length*2)%entries.length;surfaces.forEach(({count})=>{count.textContent=String(at+1).padStart(2,'0')+' / '+String(entries.length).padStart(2,'0');});};
        const complete=()=>{
          if(ticket!==generation||!busy)return;
          busy=false;onStep(steps);surfaces.forEach(({host})=>host.setAttribute('aria-busy','false'));
          root.announce(`Product view ${index+1} of ${entries.length}`);
          const pending=queued;queued=null;if(pending)select(pending.next,pending.surface,pending.origin,pending.direction);
        };
        const preserveFocus=surface.host.contains(document.activeElement),entry=entries[next];
        const allImages=route.every(item=>item.media.dataset.mediaType==='image'&&item.image);
        let handled=false;
        internalSync=true;
        try {
          handled=root.showMedia(entry.id,{
            direction,animate:allImages,duration,
            via:allImages?route.slice(1,-1).map(item=>item.image.currentSrc||item.image.src):[],
            onStep:step=>{if(handled&&allImages)onStep(step);},
            onComplete:()=>{if(handled&&allImages)complete();}
          });
        } finally { internalSync=false; }
        if(preserveFocus&&!surface.host.contains(document.activeElement))surface.host.focus({preventScroll:true});
        onStep(0);
        if(!handled||!allImages)animate(surface,route,direction,duration,onStep,complete);
      };
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      reduced.addEventListener('change',()=>{if(reduced.matches)root.showMedia(entries[index].id,{animate:false});},{signal:signal.signal});
      root.querySelectorAll('[data-pdp-opening-art]').forEach(host=>{
        host.classList.add('is-peek-gallery');host.tabIndex=0;
        host.setAttribute('role','region');host.setAttribute('aria-roledescription','carousel');host.setAttribute('aria-label','Product image gallery');
        const rail=document.createElement('div');rail.className='sv-pdp__gallery-peeks';rail.setAttribute('aria-label','Upcoming product views');
        const controls=document.createElement('div');controls.className='sv-pdp__gallery-controls';
        const count=document.createElement('span');count.className='sv-pdp__mono';count.dataset.galleryCount='';
        const prev=button('Previous product image','\u2193','previous'),next=button('Next product image','\u2191','next'),zoom=button('Enlarge current product image','\u2197','zoom');
        controls.append(prev,count,next,zoom);host.append(rail,controls);
        const surface={host,rail,controls,count,prev,next,zoom};surfaces.push(surface);
        host.addEventListener('click',event=>{
          const target=event.target.closest('[data-gallery-index],[data-gallery-action]');if(!target)return;
          if(target.dataset.galleryIndex!==undefined){select(Number(target.dataset.galleryIndex),surface,target);return;}
          if(target.dataset.galleryAction==='zoom') {
            const link=entries[index].media.querySelector('[data-pdp-zoom]');
            if(link)link.click();
            return;
          }
          const dir=target.dataset.galleryAction==='next'?1:-1;
          select(index+dir,surface,dir===1?rail.querySelector('button'):null,dir);
        },{signal:signal.signal});
        host.addEventListener('keydown',event=>{
          if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
          if(event.target.closest('input,select,textarea,video'))return;
          event.preventDefault();
          const next=event.key==='Home'?0:event.key==='End'?entries.length-1:index+(event.key==='ArrowRight'?1:-1);
          select(next,surface,null,next>index?1:-1);
        },{signal:signal.signal});
        let touch, suppressClickUntil=0;
        host.addEventListener('click',event=>{if(Date.now()<suppressClickUntil){event.preventDefault();event.stopImmediatePropagation();}},{signal:signal.signal,capture:true});
        host.addEventListener('pointerdown',event=>{if(event.pointerType==='touch')touch={x:event.clientX,y:event.clientY};},{signal:signal.signal,passive:true});
        host.addEventListener('pointerup',event=>{
          if(!touch)return;const dx=event.clientX-touch.x,dy=event.clientY-touch.y;touch=null;
          const threshold=parseFloat(getComputedStyle(document.documentElement).fontSize)*4;
          if(Math.abs(dx)>threshold&&Math.abs(dx)>Math.abs(dy)*1.5){suppressClickUntil=Date.now()+350;select(index+(dx<0?1:-1),surface,null,dx<0?1:-1);}
        },{signal:signal.signal,passive:true});
        host.addEventListener('pointercancel',()=>{touch=null;},{signal:signal.signal});
      });
      function sync(id) {
        if(!internalSync){++generation;busy=false;queued=null;surfaces.forEach(({host})=>host.setAttribute('aria-busy','false'));}
        clearTransition();
        index=Math.max(0,entries.findIndex(entry=>entry.id===String(id)));
        surfaces.forEach(surface=>{
          const {rail,count,prev,next,zoom,host}=surface;rail.replaceChildren();
          count.textContent=String(index+1).padStart(2,'0')+' / '+String(entries.length).padStart(2,'0');
          prev.hidden=next.hidden=entries.length<2;host.classList.toggle('has-next-view',entries.length>1);
          zoom.hidden=!entries[index].media.querySelector('[data-pdp-zoom]');
          for(let offset=1;offset<=Math.min(3,entries.length-1);offset++){
            const i=(index+offset)%entries.length,entry=entries[i];
            const peek=button(`Show product view ${i+1}`,'','');peek.removeAttribute('data-gallery-action');peek.dataset.galleryIndex=String(i);
            const image=(entry.thumb||entry.image)?.cloneNode();if(image){image.removeAttribute('srcset');image.removeAttribute('sizes');image.alt='';image.loading='eager';peek.append(image);}
            const label=document.createElement('span');label.className='sv-pdp__mono';label.textContent=String(i+1).padStart(2,'0');peek.append(label);rail.append(peek);
            if(entry.image)entry.image.loading='eager';
          }
        });
      }
      sync(entries[index].id);
      return { sync,dispose(){++generation;busy=false;queued=null;signal.abort();clearTransition();surfaces.forEach(({host,rail,controls})=>{rail.remove();controls.remove();host.classList.remove('is-peek-gallery','has-next-view');host.removeAttribute('tabindex');host.removeAttribute('role');host.removeAttribute('aria-roledescription');host.removeAttribute('aria-label');host.removeAttribute('aria-busy');});} };
    }
  };
})();
